import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const portNameApiSchema = v.object({
  code: v.optional(v.string()),
  id: v.number(),
  name: v.string(),
});

export const portNameSchema = v.object({
  ...portNameApiSchema.entries,
  ...optionSchema.entries,
});

export const portNamesApiSchema = paginatedSchema(portNameApiSchema);

export type PortNameApi = v.InferOutput<typeof portNameApiSchema>;
export type PortNamesApi = v.InferOutput<typeof portNamesApiSchema>;

export type PortNameFilters = Filters<PortNameApi>;

export type PortNameFiltersUpdateApi = FiltersUpdateApi<PortNameApi>;

export type PortName = Prettify<Option<v.InferOutput<typeof portNameSchema>>>;

export type PortNames = Entities<PortName>;
